import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
// TEXT MESSAGE
export const TextMessageSchema = BaseMessageDbParser.extend({
  contentType: z.literal(ContentType.TEXT),
  structuredContent: z
    .union([z.string(), z.record(z.string(), z.any()), z.object({})])
    .optional(),
});

export type NewTextMessage = z.infer<typeof TextMessageSchema>;

export const TextMessageDbParser = TextMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type TextMessage = z.infer<typeof TextMessageDbParser>;
